import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cea3ac3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "pagination-container" }
const _hoisted_4 = { class: "text-center mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-center mt-4"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No se encontraron torneos que coincidan con la búsqueda.", -1))
const _hoisted_7 = [
  _hoisted_6
]

import { ref, computed, onMounted } from "vue";
import router from "@/router";
import { getTorneos } from "@/services/TorneosService";
import LoadingGandalf from "../Commons/LoadingGandalf.vue";
import { Torneo } from "@/interfaces/Torneo";

const itemsPerPage = 6;

// Llamada a la API para obtener los torneos

export default /*#__PURE__*/_defineComponent({
  __name: 'CardTorneoLive',
  setup(__props) {

const listaTorneos = ref<Torneo[]>([]);
const isLoading = ref<boolean>(false);
const searchQuery = ref<string>("");
const currentPage = ref<number>(1);
onMounted(async () => {
  isLoading.value = true;
  try {
    const response = await getTorneos();
    listaTorneos.value = response.data;
    listaTorneos.value = listaTorneos.value.reverse();
  } catch (error) {
    console.error("Error al cargar los torneos:", error);
  } finally {
    isLoading.value = false;
  }
});

const filteredTorneos = computed(() => {
  if (!searchQuery.value) {
    return listaTorneos.value; // Si el campo está vacío o null, devolver todos los torneos
  }
  return listaTorneos.value.filter((torneo) =>
    torneo.nombreTorneo.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

// Computed para obtener los torneos de la página actual
const totalPages = computed(() =>
  Math.ceil(filteredTorneos.value.length / itemsPerPage)
);

const paginatedTorneos = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  return filteredTorneos.value.slice(start, start + itemsPerPage);
});

// Navegar al detalle del torneo
const verTorneo = (idTorneo: number) => {
  router.push({ name: "detalle-torneo-live", params: { idTorneo } });
};

// Función para resetear la página a 1 cuando se empieza a escribir
const resetPage = () => {
  currentPage.value = 1;
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingGandalf)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_v_container, { class: "mb-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              justify: "center",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: searchQuery.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      label: "Buscar torneo",
                      clearable: "",
                      tonal: "",
                      dense: "",
                      "append-icon": "mdi-magnify",
                      class: "elevated-search",
                      onInput: resetPage
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedTorneos.value, (torneo) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: torneo.idTorneo,
                    cols: "12",
                    sm: "6",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "hover-card",
                        tonal: "",
                        onClick: ($event: any) => (verTorneo(torneo.idTorneo)),
                        role: "button",
                        tabindex: "0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: torneo.cartelTorneo,
                            height: "200",
                            cover: ""
                          }, null, 8, ["src"]),
                          _createVNode(_component_v_card_title, { class: "text-wrap justify-center text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(torneo.nombreTorneo), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_pagination, {
            modelValue: currentPage.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
            length: totalPages.value,
            class: "mt-4 justify-center",
            size: "large",
            color: "primary",
            variant: "tonal",
            disabled: filteredTorneos.value.length === 0
          }, null, 8, ["modelValue", "length", "disabled"]),
          _createElementVNode("p", _hoisted_4, " Página " + _toDisplayString(currentPage.value) + " de " + _toDisplayString(totalPages.value), 1)
        ]),
        (filteredTorneos.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true)
      ]))
}
}

})